export default __webpack_public_path__ + "static/media/iconn.91da0f62.png";